export default __webpack_public_path__ + "static/media/Gif logo sa slovima.10774a0a.gif";